/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import Vue from 'vue';
import { render } from '../lib';
import { VimeCaptions } from '@vime/core';
import { define } from '../lib';
define('vime-captions', VimeCaptions);
export default Vue.extend({
    props: {
        hidden: {},
        controlsHeight: {},
        isControlsActive: {},
        isVideoView: {},
        playbackStarted: {},
        textTracks: {},
    },
    methods: {},
    render: render('vime-captions', ['vTrackChange', 'vCuesChange']),
});
//# sourceMappingURL=VimeCaptions.js.map